import React, { Component } from 'react';
import QRCode from 'qrcode';
import { displayError } from "helpers";
import {
  LineButton
} from "appStyles";

class QRCodeGenerator extends Component {
  state = {
    url: ''
  }

  componentDidMount(){
    this.downloadQrImage();
  }

  componentDidUpdate(prevProps){
    if(prevProps.text !== this.props.text){
      this.downloadQrImage();
    }
  }

  downloadQrImage = () => {
    const { text, width } = this.props;
    if(text){
      return QRCode.toDataURL(text, {
        width: width || 200
      })
        .then(url => {
          this.setState({url});
        })
        .catch(err => {
          console.error(err);
        });
    }else{
      this.setState({url: ''});
    }
  }  

  render() {
    const { url } = this.state;
    const { name } = this.props;

    return (
      <LineButton onClick={() => {
        if (!url) return displayError('The QR code is generated based off your deal password, so it can’t be empty.');
      }}>
        {url ? <a href={url} download={name}>Download QR Code</a> : 'Download QR Code'}
      </LineButton>
    )
  }
}

export default QRCodeGenerator;